import { getCookie } from "cookies-next";
import { useEffect, useState } from "react";

import { AdminRole } from "@/types/common";

export interface AuthState {
  adminToken: string | null;
  adminRole: AdminRole | null;
  /** JWT payload의 백엔드 역할 (SUPER | STAFF). 파싱 실패 시 null */
  backendRole: string | null;
  adminId: number | null;
  adminEmail: string | null;
  isAuthenticated: boolean;
}

// JWT payload에서 role 클레임을 추출한다 (백엔드가 { sub, role }로 서명)
const parseTokenRole = (token: string | null): string | null => {
  if (!token) return null;
  try {
    const payloadPart = token.split(".")[1];
    if (!payloadPart) return null;
    const payload = JSON.parse(
      atob(payloadPart.replace(/-/g, "+").replace(/_/g, "/")),
    );
    return typeof payload.role === "string" ? payload.role : null;
  } catch {
    return null;
  }
};

// JWT sub 클레임(어드민 id) 추출
const parseTokenSub = (token: string | null): number | null => {
  if (!token) return null;
  try {
    const payloadPart = token.split(".")[1];
    if (!payloadPart) return null;
    const payload = JSON.parse(
      atob(payloadPart.replace(/-/g, "+").replace(/_/g, "/")),
    );
    const sub = Number(payload.sub);
    return Number.isInteger(sub) ? sub : null;
  } catch {
    return null;
  }
};

export const useAdminAuth = (): AuthState => {
  const [authState, setAuthState] = useState<AuthState>({
    adminToken: null,
    adminRole: null,
    backendRole: null,
    adminId: null,
    adminEmail: null,
    isAuthenticated: false,
  });

  useEffect(() => {
    const token = getCookie("adminToken") as string;
    const role = getCookie("adminRole") as AdminRole;
    const email = getCookie("adminEmail") as string;

    setAuthState({
      adminToken: token || null,
      adminRole: role || null,
      backendRole: parseTokenRole(token || null),
      adminId: parseTokenSub(token || null),
      adminEmail: email || null,
      isAuthenticated: !!token,
    });
  }, []);

  return authState;
};
